'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-article-functions',
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 * @returns 
 */

function ArticleFunctions(_ref) {
  var bodyPrefix = _ref.bodyPrefix,
      bodySuffix = _ref.bodySuffix,
      className = _ref.className,
      labelPrint = _ref.labelPrint,
      labelSend = _ref.labelSend,
      subject = _ref.subject;

  if (typeof window === 'undefined') {
    return null;
  } // TODO check encoding


  var body = window.encodeURIComponent("".concat(bodyPrefix, "\n\n").concat(window.location.href, "\n\n").concat(bodySuffix));
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnButtons
  }, labelSend && /*#__PURE__*/React__default.createElement(ButtonLink, {
    iconLeft: "paper-plane",
    title: labelSend,
    className: cnButton,
    link: "mailto:?subject=".concat(window.encodeURIComponent(subject), "&body=").concat(body)
  }), labelPrint && /*#__PURE__*/React__default.createElement(ButtonLink, {
    iconLeft: "printer",
    title: labelPrint,
    className: cnButton,
    onClick: function onClick() {
      return window.print();
    }
  })));
}
ArticleFunctions.propTypes = {
  /** Email body before shared link */
  bodyPrefix: PropTypes.string,

  /** Email body after shared link */
  bodySuffix: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** Label for print button */
  labelPrint: PropTypes.string,

  /** Label for send button */
  labelSend: PropTypes.string,

  /** Email subject */
  subject: PropTypes.string
};
ArticleFunctions.defaultProps = {
  bodyPrefix: '',
  bodySuffix: '',
  subject: ''
};

module.exports = ArticleFunctions;
